import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useAuth } from "../../../hooks/use-auth";
import { useMounted } from "../../../hooks/use-mounted";
import {
  Box,
  Button,
  Card,
  Chip,
  Container,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { OverviewBanner } from "../overview/overview-banner";
import { CallCenterAnalytics } from "../callCenter/call-center-analytics";
import { ContactosGenerales } from "../callCenter/call-center-contactos";
import { LeadsGenerales } from "../callCenter/call-center-leads";
import { CallCenterContactosListResumen } from "../callCenter/call-center-contactos-list";

export const DashboardContainerCallcenter = (props) => {
  const isMounted = useMounted();
  const { user } = useAuth();

  const [displayBanner, setDisplayBanner] = useState(true);
  const [contactos, setContactos] = useState([]);
  const [contactosCount, setContactosCount] = useState(0);
  const [leadsCount, setLeadsCount] = useState(0);
  const [leadsStatus, setLeadsStatus] = useState({});

  const [maxContactos, setMaxContactos] = useState(10);

  // Obtiene la hora actual del usuario
  const currentHour = new Date().getHours();
  const mensajeBienvenida =
    currentHour >= 6 && currentHour < 12
      ? "Buenos días"
      : currentHour >= 12 && currentHour < 20
      ? "Buenas tardes"
      : "Buenas noches";

  useEffect(() => {
    const value = globalThis.sessionStorage.getItem("dismiss-banner");
    if (value === "true") {
      setDisplayBanner(false);
    }
  }, []);

  const handleDismissBanner = () => {
    // Update the persistent state
    globalThis.sessionStorage.setItem("dismiss-banner", "true");
    setDisplayBanner(false);
  };

  const getLeadsCount = async () => {
    try {
      const response = await fetch(
        `/api/v1/call-center/countLeads?userRole=${user.role}&userId=${user.id}`
      );
      const data = await response.json();
      console.log(data);

      if (data.ok) {
        setLeadsCount(data.contactos);
        console.log(data.status);

        setLeadsStatus(data.status);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getContactosCount = async () => {
    try {
      const response = await fetch(
        `/api/v1/call-center/countContactos?userRole=${user.role}&userId=${user.id}&maxContactos=${maxContactos}`
      );
      const data = await response.json();
      console.log(data);

      if (data.ok) {
        setContactosCount(data.cuenta);
        setContactos(data.contactos);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isMounted()) {
      getContactosCount();
      getLeadsCount();
    }
    console.log(user);
  }, [isMounted]);

  return (
    <Container maxWidth="xl">
      <Box sx={{ mb: 4 }}>
        <Grid container justifyContent="space-between" spacing={3}>
          <Grid item>
            <Typography variant="h4">
              {mensajeBienvenida}, {user?.name ?? "Usuario"}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={4}>
        {displayBanner && (
          <Grid item xs={12}>
            <OverviewBanner onDismiss={handleDismissBanner} />
          </Grid>
        )}
        {/* 
        <Grid item md={4} xs={12}>
          <ContactosGenerales contactosCount={contactosCount} user={user} />
        </Grid>
        
        <Grid
          item
          md={8}
          xs={12}
        >
          <CallCenterContactosListResumen
            contactos={contactos}
            user={user}
          />
        </Grid>
        <Grid
          item
          md={12}
          xs={12}
        >
          <Typography
            color="textPrimary"
            variant="h5"
          >
            {user?.role === 'callcenteradmin' ? 'Solicitudes de contacto' : 'Tus soliciudes de contacto'}
          </Typography>
        </Grid>

        <Grid
          item
          md={4}
          xs={12}
        >
          <LeadsGenerales
            contactosCount={leadsCount}
            user={user}
          />
        </Grid>

        <Grid
          item
          md={8}
          xs={12}
        >
          {
            leadsStatus.length > 0 && (
              <CallCenterAnalytics 
                user={user}
                status={leadsStatus}
              />
            )
          }
        </Grid> */}
      </Grid>
    </Container>
  );
};
